"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = require("ramda");

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _container = _interopRequireDefault(require("../../legacy/container"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

var _diagramSlider = _interopRequireDefault(require("./diagram-slider"));

var _diagram = _interopRequireDefault(require("./diagram"));

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

var _excluded = ["itemsCount"],
    _excluded2 = ["id", "image", "title", "titleColor"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var BlockDiagramContainer = (0, _styledComponents["default"])(_gridSystem["default"].Wrapper).withConfig({
  displayName: "block-diagram__BlockDiagramContainer",
  componentId: "sc-wmtl33-0"
})(["position:relative;"]);
var SliderWrapper = (0, _styledComponents["default"])(function (_ref) {
  var itemsCount = _ref.itemsCount,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, props);
}).withConfig({
  displayName: "block-diagram__SliderWrapper",
  componentId: "sc-wmtl33-1"
})(["", ";"], function (props) {
  return props.itemsCount > 1 ? "overflow: hidden;" : "";
});
var propTypes = {
  /** Background color */
  backgroundColor: _propTypes.string,

  /** setting for bottom padding amount * */
  bottomUnitPadding: _propTypes.number,
  // Class name for styled components
  className: _propTypes.string,

  /** Custom Background React component  */
  customBackground: _propTypes.func,
  // Custom html id used for targeting component
  htmlId: _propTypes.string,

  /** Block diagram content */
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    /** Tout id */
    id: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]).isRequired,

    /** Tout img src url */
    image: _propTypes.string,

    /** Title content */
    title: _propTypes.node,

    /** Title color override */
    titleColor: _propTypes.string
  })).isRequired,
  // Theme object
  theme: _utils.themePropType,

  /** setting for top padding amount * */
  topUnitPadding: _propTypes.number
};
var defaultProps = {
  backgroundColor: "background-light",
  bottomUnitPadding: 2,
  topUnitPadding: 2
};

var BlockDiagram = function BlockDiagram(_ref2) {
  var backgroundColor = _ref2.backgroundColor,
      bottomUnitPadding = _ref2.bottomUnitPadding,
      className = _ref2.className,
      customBackground = _ref2.customBackground,
      htmlId = _ref2.htmlId,
      items = _ref2.items,
      theme = _ref2.theme,
      topUnitPadding = _ref2.topUnitPadding;
  return /*#__PURE__*/_react["default"].createElement(BlockDiagramContainer, {
    backgroundColor: backgroundColor,
    className: className,
    htmlId: htmlId,
    tag: customBackground
  }, /*#__PURE__*/_react["default"].createElement(_container["default"], {
    alignItems: "center",
    justifyContent: "center",
    maxWidth: 1440,
    pb: theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return bottomUnitPadding * padding;
    }),
    pt: theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return topUnitPadding * padding;
    }),
    px: 0
  }, /*#__PURE__*/_react["default"].createElement(SliderWrapper, {
    itemsCount: items.length
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, null, /*#__PURE__*/_react["default"].createElement(_diagramSlider["default"], null, (0, _ramda.map)(function (_ref3) {
    var id = _ref3.id,
        image = _ref3.image,
        title = _ref3.title,
        titleColor = _ref3.titleColor,
        rest = _objectWithoutPropertiesLoose(_ref3, _excluded2);

    return /*#__PURE__*/_react["default"].createElement(_diagram["default"], _extends({
      key: id,
      image: image,
      title: title,
      titleColor: titleColor
    }, rest));
  }, items))))));
};

BlockDiagram.propTypes = propTypes;
BlockDiagram.defaultProps = defaultProps;
BlockDiagram.displayName = "Modules.BlockDiagram";

var _default = (0, _styledComponents.withTheme)(BlockDiagram);

exports["default"] = _default;